import React from 'react';
import { Hero } from './components/Hero';
import { ProofStrip } from './components/ProofStrip';
import { PainPoints } from './components/PainPoints';
import { Tomos } from './components/Tomos';
import { Bonos } from './components/Bonos';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyCTA } from './components/StickyCTA';
import { Testimonials, firstWave, secondWave } from './components/Testimonials';
export function App() {
  return <div className="w-full bg-cream font-sans" data-id="element-0" data-mp="31c9ygdv1bhw7">
      <Hero data-id="element-1" data-mp="2wk9y4kb1ymz3" />
      <Testimonials items={firstWave} data-id="element-2" data-mp="2wjqgz5t882m4" />
      <ProofStrip data-id="element-3" data-mp="2wip7v6vrtq71" />
      <main data-id="element-4" data-mp="2wi5l9cv6edmo">
        <PainPoints data-id="element-5" data-mp="28u5y0mx2p5cu" />
        <Tomos data-id="element-6" data-mp="28tmg367fagyt" />
        <Bonos data-id="element-7" data-mp="28t4mkhc5agul" />
        <Pricing data-id="element-8" data-mp="28sur4e8bzhhi" />
        <Guarantee data-id="element-9" data-mp="28sbe9bxjfjac" />
        <FAQ data-id="element-10" data-mp="23vkw8j26adma" />
        <Testimonials items={secondWave} variant="dark" title="Lo que cambió en sus cocinas" data-id="element-11" data-mp="23vupcfiil0w7" />
        <FinalCTA data-id="element-12" data-mp="3ijfx0558q6h9" />
      </main>
      <Footer data-id="element-13" data-mp="3ii4ro0w5cqo1" />
      <StickyCTA data-id="element-14" data-mp="3mlawr57iwbsx" />
    </div>;
}